import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  ADMIN_ORDERS,
  ADMIN_PRODUCTS,
  ADMIN_PRODUCTS_CHANGE_STATUS,
  ADMIN_SECTION,
  ADMIN_SECTION_VIDEOS_SUGGESTIONS,
  ATTRIBUTE_MASTER,
  BRAND_COMMON,
  BUNDLES,
  COUPON_CURD,
  COUPON_LIST,
  CREATE_BRANDS,
  CREATE_OR_GET_BANNER,
  GET_BANNER_LAYOUT,
  GET_OR_UPDATE_BANNER_BY_ID,
  GET_SCREEN_AND_SCREEN_SECTIONS,
  UPDATE_DISPLAY_ORDER,
} from "../../../config/apiUrlsAdmin";
import {
  CreateCouponRequest,
  IAddEditProductSingleRequest,
  IAdminOrderDetailsResponse,
  IAdminOrdersRequest,
  IAdminOrdersResponse,
  IChangeBrandStatusRequest,
  IChangeBundleStatusRequest,
  ICreateBannerRequest,
  ICreateBrandRequest,
  ICreateBundleRequest,
  ICreateHomepageSectionItemsRequest,
  ICreateHomepageSectionRequest,
  IGetAttributeRequest,
  IGetBannersRequest,
  IGetCouponsRequest,
  IGetProductsRequest,
  ISectionIdsRequest,
  IUpdateBannerOrderRequest,
  IUpdateSectionStatusRequest,
} from "../../../types/Request/AdminRequest";
import {
  GetCouponsResponse,
  IAdminProductsByIdResponse,
  IAdminProductsResponse,
  IBrandResponse,
  IChangeProductStatusResponse,
  ICoupon,
  ICreateBannerResponse,
  ICreateBrandResponse,
  ICreateBundleResponse,
  ICreateScreenResponse,
  IGetAttributeMasterResponse,
  IGetAttributeValuesResponse,
  IGetBannerByIdResponse,
  IGetBannersResponse,
  IGetBundleByIdResponse,
  IGetBundlesResponse,
  IGetScreenOptionsResponse,
  IGetScreensResponse,
  IGetSectionDisplayOrderResponse,
  IHomepageSectionItem,
  IHomepageSectionItemsResponse,
  IScreenDashboardResponse,
  IUpdateBundleStatusResponse,
  VideoSuggestionsResponse,
} from "../../../types/Response/AdminResponse";

export const adminProductAPi = createApi({
  reducerPath: "adminProductAPi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Products"], // Add this tag type

  endpoints: (builder) => ({
    createBrand: builder.mutation<ICreateBrandResponse, ICreateBrandRequest>({
      query: (data) => ({
        url: CREATE_BRANDS,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    UpdateBrand: builder.mutation<
      ICreateBrandResponse,
      { id: number; data: any }
    >({
      query: ({ id, data }) => ({
        url: `${BRAND_COMMON}/${id}/update`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    GetAllBrands: builder.query<IBrandResponse[], void>({
      query: () => ({
        url: BRAND_COMMON,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),
    UpdateBrandStatus: builder.mutation<
      ICreateBrandResponse,
      { id: number; data: IChangeBrandStatusRequest }
    >({
      query: ({ id, data }) => ({
        url: `${BRAND_COMMON}/${id}/change-status`,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),

    /////   BANNER /////
    createBanner: builder.mutation<ICreateBannerResponse, ICreateBannerRequest>(
      {
        query: (data) => ({
          url: CREATE_OR_GET_BANNER,
          method: "post",
          data: data,
        }),
        invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
      },
    ),
    UpdateBanner: builder.mutation<
      ICreateBannerResponse,
      { id: number; data: ICreateBannerRequest }
    >({
      query: ({ id, data }) => ({
        url: `${GET_OR_UPDATE_BANNER_BY_ID}/${id}`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    GetBannerById: builder.query<IGetBannerByIdResponse, number>({
      query: (id) => ({
           url: `${GET_OR_UPDATE_BANNER_BY_ID}/id?id=${id}`,

        method: "get",
      }),
    }),
    GetAllBanner: builder.query<IGetBannersResponse, IGetBannersRequest>({
      query: (data) => ({
        url: CREATE_OR_GET_BANNER,
        method: "get",
        params: data,
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),
    GetBannerLayout: builder.query<IGetScreensResponse, void>({
      query: () => ({
        url: GET_BANNER_LAYOUT,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    UpdateBannerStatus: builder.mutation<
      ICreateBannerResponse,
      { id: number; data: IChangeBrandStatusRequest }
    >({
      query: ({ id, data }) => ({
        url: `${CREATE_OR_GET_BANNER}/${id}/status`,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    UpdateBannerDisplayOrder: builder.mutation<
      any,
      { id: number; data: IUpdateBannerOrderRequest }
    >({
      query: ({ id, data }) => ({
        url: `${UPDATE_DISPLAY_ORDER}`,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),

    

    DeleteBanner: builder.query<any, Number>({
      query: (id) => ({
        url: `${GET_OR_UPDATE_BANNER_BY_ID}/${id}`,
        method: "delete",
      }),
    }),

    ////// SCREEN  ///

    GetBannerDashboard: builder.query<IScreenDashboardResponse, number>({
      query: (id) => ({
        url: `${GET_SCREEN_AND_SCREEN_SECTIONS}/${id}/banner-dashboard`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    //////  COUPON ////
    createCoupon: builder.mutation<number, CreateCouponRequest>({
      query: (data) => ({
        url: COUPON_CURD,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    UpdateCoupon: builder.mutation<Boolean, CreateCouponRequest>({
      query: (data) => ({
        url: COUPON_CURD,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    GetCouponList: builder.mutation<GetCouponsResponse, IGetCouponsRequest>({
      query: (data) => ({
        url: COUPON_LIST,
        method: "post",
        data: data,
      }),
    }),

    GetCouponById: builder.query<ICoupon, Number>({
      query: (id) => ({
        url: `${COUPON_CURD}/${id}`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    deleteCoupon: builder.query<Boolean, Number>({
      query: (id) => ({
        url: `${COUPON_CURD}/${id}`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    getAdminProducts: builder.query<
      IAdminProductsResponse,
      IGetProductsRequest
    >({
      query: (data) => ({
        url: ADMIN_PRODUCTS,
        method: "get",
        data: data,
      }),
    }),

    getAdminProductsById: builder.query<IAdminProductsByIdResponse, number>({
      query: (id) => ({
        url: `${ADMIN_PRODUCTS}/${id}`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    AdminAddSingleProduct: builder.mutation<
      Boolean,
      IAddEditProductSingleRequest
    >({
      query: (data) => ({
        url: ADMIN_PRODUCTS,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    AdminUpdateSingleProduct: builder.mutation<
      Boolean,
      { data: IAddEditProductSingleRequest; id: number }
    >({
      query: ({ data, id }) => ({
        url: `${ADMIN_PRODUCTS}/${id}`,
        method: "put",
        data: data,
      }),
       invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),

    /////  Bundels API /////
    createBundle: builder.mutation<ICreateBundleResponse, ICreateBundleRequest>(
      {
        query: (data) => ({
          url: BUNDLES,
          method: "post",
          data: data,
        }),
        invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
      },
    ),
    UpdateBundle: builder.mutation<
      ICreateBundleResponse,
      { id: number; data: ICreateBundleRequest }
    >({
      query: ({ id, data }) => ({
        url: `${BUNDLES}/${id}`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    GetAllBundle: builder.query<IGetBundlesResponse, void>({
      query: () => ({
        url: BUNDLES,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),
    UpdateBundleStatus: builder.mutation<
      IUpdateBundleStatusResponse,
      { id: number; data: IChangeBundleStatusRequest }
    >({
      query: ({ id, data }) => ({
        url: `${BUNDLES}/${id}/status`,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    GetBundleById: builder.query<IGetBundleByIdResponse, number>({
      query: (id) => ({
        url: `${BUNDLES}${id}`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),
    deleteBundle: builder.query<IUpdateBundleStatusResponse, number>({
      query: (id) => ({
        url: `${BUNDLES}/${id}`,
        method: "delete",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    GetAttributeMater: builder.query<
      IGetAttributeMasterResponse,
      IGetAttributeRequest
    >({
      query: (data) => ({
        url: ATTRIBUTE_MASTER,
        method: "get",
        data: data,
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    GetAttributeMaterValues: builder.query<IGetAttributeValuesResponse, number>(
      {
        query: (id) => ({
          url: `${ATTRIBUTE_MASTER}/${id}/values`,
          method: "get",
        }),
        providesTags: ["Products"], // Listens for invalidations
      },
    ),

    UpdateProductStatus: builder.mutation<
      IChangeProductStatusResponse,
      { id: number; data: IChangeBrandStatusRequest }
    >({
      query: ({ id, data }) => ({
        url: `${ADMIN_PRODUCTS_CHANGE_STATUS}/${id}/active-status`,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    //////  ADMIN SCREEN FOR REORDER AND ALL //

    GetScreen: builder.query<IGetScreenOptionsResponse, void>({
      query: () => ({
        url: GET_SCREEN_AND_SCREEN_SECTIONS,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),
    GetScreenSections: builder.query<IGetSectionDisplayOrderResponse, number>({
      query: (id) => ({
        url: `${GET_SCREEN_AND_SCREEN_SECTIONS}/${id}/section`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),
    createScreenSections: builder.mutation<
      ICreateScreenResponse,
      { id: number; data: ICreateHomepageSectionRequest }
    >({
      query: ({ id, data }) => ({
        url: `${GET_SCREEN_AND_SCREEN_SECTIONS}/${id}/sections`,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    updateScreenSections: builder.mutation<
      ICreateScreenResponse,
      { id: number; data: ICreateHomepageSectionRequest }
    >({
      query: ({ id, data }) => ({
        url: `${ADMIN_SECTION}/${id}`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    reorderScreenSections: builder.mutation<
      any,
      { screenId: number; data: ISectionIdsRequest }
    >({
      query: ({ screenId, data }) => ({
        url: `${GET_SCREEN_AND_SCREEN_SECTIONS}/${screenId}/sections/reorder`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    GetSectionItems: builder.query<IHomepageSectionItemsResponse, number>({
      query: (sectionId) => ({
        url: `${ADMIN_SECTION}/${sectionId}/items`,
        method: "get",
      }),
      providesTags: ["Products"], // Listens for invalidations
    }),

    UpdateSectionItem: builder.mutation<
      any,
      { sectionId: number; data: ICreateHomepageSectionItemsRequest }
    >({
      query: ({ sectionId, data }) => ({
        url: `${ADMIN_SECTION}/${sectionId}/items`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
    getAvailableSectionItems: builder.query<
      IHomepageSectionItem[],
      {
        sectionId: number;
        itemType: string;
        search?: string;
        take?: number;
      }
    >({
      query: ({ sectionId, itemType, search, take = 50 }) => ({
        url: `${ADMIN_SECTION}/${sectionId}/available-items`,
        method: "get",
        params: {
          itemType,
          search,
          take,
        },
      }),
    }),
       getAvailableVideos: builder.query<
  VideoSuggestionsResponse,
  {
    sectionType: string;
    limit?: number;
  }
>({
  query: ({ sectionType, limit = 10 }) => ({
    url: ADMIN_SECTION_VIDEOS_SUGGESTIONS,
    method: "get",
    params: {
      sectionType,
      limit,
    },
  }),
}),
    deleteScreenSection: builder.mutation<any, number>({
      query: (sectionId) => ({
        url: `${ADMIN_SECTION}/${sectionId}`,
        method: "delete",
      }),
      invalidatesTags: ["Products"],
    }),


    
    updateSectionStatus: builder.mutation<
      any,
      { sectionId: number; data: IUpdateSectionStatusRequest }
    >({
      query: ({ sectionId, data }) => ({
        url: `${ADMIN_SECTION}/${sectionId}/status`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Products"], // Invalidates cache to trigger refetch
    }),
  }),
});

export const {
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useUpdateBrandStatusMutation,
  useLazyGetAllBrandsQuery,

  useCreateBannerMutation,
  useUpdateBannerDisplayOrderMutation,
  useUpdateBannerMutation,
  useUpdateBannerStatusMutation,
  useLazyGetAllBannerQuery,
  useLazyGetBannerLayoutQuery,
  useLazyDeleteBannerQuery,
  useLazyGetBannerByIdQuery,

  useLazyGetBannerDashboardQuery,

  useLazyDeleteCouponQuery,
  useLazyGetCouponByIdQuery,
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useGetCouponListMutation,
  useLazyGetAdminProductsQuery,

  useLazyGetAdminProductsByIdQuery,
  useAdminAddSingleProductMutation,
  useAdminUpdateSingleProductMutation,

  useCreateBundleMutation,
  useUpdateBundleMutation,
  useLazyGetBundleByIdQuery,
  useLazyGetAllBundleQuery,
  useLazyDeleteBundleQuery,
  useUpdateBundleStatusMutation,

  useLazyGetAttributeMaterQuery,
  useLazyGetAttributeMaterValuesQuery,

  useUpdateProductStatusMutation,

  useLazyGetScreenQuery,
  useLazyGetScreenSectionsQuery,
  useCreateScreenSectionsMutation,
  useUpdateScreenSectionsMutation,
  useLazyGetSectionItemsQuery,
  useUpdateSectionItemMutation,
  useReorderScreenSectionsMutation,
  useLazyGetAvailableSectionItemsQuery,
  useDeleteScreenSectionMutation,
  useUpdateSectionStatusMutation,
  useLazyGetAvailableVideosQuery
} = adminProductAPi;
